var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"d-inline-block",staticStyle:{"width":"80px"},attrs:{"items":_vm.languages,"item-text":"title","item-value":"id","outlined":"","dense":"","hide-details":"auto"},model:{value:(_vm.currentLanguage),callback:function ($$v) {_vm.currentLanguage=$$v},expression:"currentLanguage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }